module.exports = __webpack_public_path__ + "static/media/blog5.92a02d6a.jpg";